import './home.css';
import '../about/about.css'
import { conCategorias } from '../../conexiones/varConexiones.js';
import { conCursos,conExperiencia } from '../../conexiones/varConexiones.js';
import { useSelector } from 'react-redux';
import React, {useEffect, useState } from 'react';
import { Suspense } from 'react';
import {fetchData} from '../../fetch/fetchData.js';
import Bloque from '../../componentes/bloque_queHago/Bloque.js';
import Slide from '../../componentes/slide/Slide';
import Seccion from '../../componentes/seccion/Seccion';
import Modal from '../../componentes/modal/Modal';
import Bannercaso from '../../componentes/BannerCaso/Banner_caso.js';
import casos from '../../componentes/Caso/casos.js';
import homewords from './homeDictionary.js';
import aboutwords from '../about/aboutDictionary.js';
import Pod from '../../componentes/pod/Pod';

const apiData = fetchData(conCategorias);
const apiData2 = fetchData(conCursos);
const apiData3 = fetchData(conExperiencia);

const Home = (props) => {
  const lang = useSelector((state) => state.lang.lang);
  const dataCasos = casos;
  const data = apiData.read();
  const [estadoModal,cambiaEstadoModal] = useState({type:null,on:false,id:null,scroll:true});
  const data2 = apiData2.read();
  const data3 = apiData3.read();

  function scrollingWindows (){
    if(estadoModal.scroll === true){
      return window.scrollY > 0 ? window.scroll({top: 0,behavior: "smooth"}):null;
    }
  }
/*   useEffect(()=>{
    scrollingWindows()
  }) */
  return (
    <>
      <Modal estado={estadoModal} cambiarEstado={cambiaEstadoModal}></Modal>
      <><Slide /></>
      <>
        <Suspense fallback={<div>Cargando...</div>}>
          <div className='central'>
          <Bloque />
          <div className='central-trabajos' style={{width:'100%', boxSizing:'border-box'}} ref={props.mainref}>
            {/* casos */}
            <div className='central-casos'>
              <h3 className='central-casos-titulo'>{Object.values(homewords.titulo[lang])}</h3>
                {Object.values(dataCasos).map((caso) => {
                  return caso.state === 'ok'? <Bannercaso key={caso.id} id={caso.id} thum={caso.thum} textos={caso[lang]} />:''
                })}
            </div>
            {data?.listacategorias.map(
              (cat)=>(
                  <Seccion key={cat.id_cat} categoria={Object.values(homewords[cat.nombre_categoria][lang])} catId={cat.id_cat} action={cambiaEstadoModal}></Seccion>
              ))
            }
            </div>
            <div className="body_aboutme" ref={props.secref}>
              <div className="section_aboutme_experiencia">
                <div className="section_aboutme_block">
                    <h3>{Object.values(aboutwords.abtstt1[lang])}{/* {languageSwitch(dictionary.abtstt1,lang)} */}</h3>
                    {/* <p className="experiencia_bajada">{languageSwitch(dictionary.abtstdes1,lang)}</p> */}
                    <div className="lineatiempo" id="educacion" data-targ="educacion">
                      {data2?.listacursos.map(//mapeando la lista de cursos
                                    (ed)=>{
                                        return <Pod key={ed.id_ed} objeto={ed} type={'ed'}></Pod>
                                    }
                                )}
                    </div>
                </div>
                <div className="section_aboutme_block">
                    <h3>{Object.values(aboutwords.abtstt2[lang])}{/* {languageSwitch(dictionary.abtstt2,lang)} */}</h3>
                    {/* <p className="experiencia_bajada">{languageSwitch(dictionary.abtstdes2,lang)}</p> */}
                    <div className="lineatiempo" id="experiencia" data-targ="experiencia">
                    {data3?.listaexperiencias.map(//mapeando la lista de cursos
                                    (exp)=>{
                                        return <Pod key={exp.id_exp} objeto={exp} type={'exp'} />
                                    }
                                )}
                    </div>
                </div>
              </div>
            </div>

          </div>
        </Suspense>
      </>
      </>
  );
}

export default Home;
